export class RFParamSetElement {
  RFParamSetID: string = "";
  RFParamSetTimestamp: Date;
  ActilityRFParamSet: string = "";

  constructor(
    RFParamSetID: string = "",
    RFParamSetTimestamp: Date = new Date(),
    ActilityRFParamSet: string = "") {

    this.RFParamSetID = RFParamSetID;
    this.RFParamSetTimestamp = RFParamSetTimestamp;
    this.ActilityRFParamSet = ActilityRFParamSet;
  }

  isValid() {
    if(this.RFParamSetID.length > 0 && this.ActilityRFParamSet.length > 0) return true;
    else return false;
  }

}
